import React, { Component } from 'react';

class IconStatusCheckDisabled extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="22"
                fill="none"
                viewBox="0 0 23 22"
            >
                <path
                    fill="#CCC"
                    fillRule="evenodd"
                    d="M11.602 0C5.478 0 .512 4.925.512 11s4.966 11 11.09 11c6.125 0 11.09-4.925 11.09-11S17.727 0 11.602 0zm4.807 9.14a.998.998 0 00.137-1.118 1.002 1.002 0 00-.601-.497 1.016 1.016 0 00-1.084.335l-4.335 5.159-2.244-2.226a1.012 1.012 0 00-1.413.012.996.996 0 00-.012 1.402l3.024 3a1.01 1.01 0 001.161.188c.126-.061.237-.148.326-.255l5.041-6z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    }
}

export default IconStatusCheckDisabled;